import { Loadable } from '../Loadable';

export const AsyncForceError = Loadable(() => import('./ForceError'));
export const AsyncClearAllOrders = Loadable(() => import('./ClearOrder'));
export const AsyncCheckPOSPrice = Loadable(() => import('./CheckPOSPrice'));
